document.addEventListener('DOMContentLoaded', () => {
  // Wait for the custom element to be defined and upgraded
  customElements.whenDefined('shopify-forms-embed').then(() => {
    const injectStyles = () => {
      const embeds = document.querySelectorAll('shopify-forms-embed');
      embeds.forEach(embed => {
        const shadow = embed.shadowRoot;
        if (shadow && !shadow.querySelector('#custom-overrides')) {
          const style = document.createElement('style');
          style.id = 'custom-overrides';
          style.textContent = `
            [name="custom#agreement"] legend {
              display: none;
            }
            #app-embed ._container_3eyaa_70 {
                display: block;
                padding-left: 22px;
                padding-right: 22px;
                margin-block: auto;
                box-sizing: border-box;
            }
            #app-embed [data-testid="banner-success"] {
              background: #162950;
              padding-block: 7px;
            }

            #app-embed [data-testid="banner-success"] font,
            #app-embed [data-testid="banner-success"] p,
            #app-embed [data-testid="banner-success"] h2 {
              color: #fff;
            }
          `;
          shadow.appendChild(style);
        }
      });
    };
    
    // Try immediately, then observe for lazy-loaded embeds
    injectStyles();
    const observer = new MutationObserver(injectStyles);
    observer.observe(document.body, { childList: true, subtree: true });
  });
});